import axios from 'axios';

class Api {
	static headers() {
		return {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		};
	}

	/**
	 * Fetch a url from the API
	 * @param {string} url
	 * @returns {Promise<*>}
	 */
	static get(url, config = {}) {
		return this.xhr('get', url, {}, config);
	}

	static post(url, data = {}, config = {}) {
		return this.xhr('post', url, data, config);
	}

	static put(url, data = {}, config = {}) {
		return this.xhr('put', url, data, config);
	}

	static patch(url, data = {}, config = {}) {
		return this.xhr('patch', url, data, config);
	}

	static delete(url, data = {}, config = {}) {
		return this.xhr('delete', url, data, config);
	}

	static getApiURL() {
		return process.env.REACT_APP_API_URL;
	}

	/**
	 * Base fetch method. Should not be used directly, but through above functions.
	 * @param method
	 * @param url
	 * @returns {Promise<*>}
	 */
	static async xhr(method, url, data = {}, config = {}) {
		const API_URL = this.getApiURL();
		const headers = {
			...this.headers(),
			...config,
		};
		const options = {
			method,
			data,
			headers,
			// withCredentials: true,
			url: `${API_URL}/${url}`,
		};

		const xhrResult = await axios(options);
		return xhrResult.data;
	}
}

export default Api;
